import { jsx as _jsx } from "react/jsx-runtime";
import BaseDatePickerFormV2 from '@libs/@core/components/forms/BaseDatePickerFormV2';
import BaseTextFieldForm from '@libs/@core/components/forms/BaseTextFieldForm';
import BaseSelectForm from '@libs/@core/components/forms/BaseSelectForm';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var status = [
    { value: 'Published', label: 'Published' },
    { value: 'Draft', label: 'Draft' },
    { value: 'Unpublished', label: 'Unpublished' }
];
var useGetFilterList = function () {
    var t = useCustomTranslation();
    var listFilters = [
        _jsx(BaseTextFieldForm, { name: 'id', label: t('L000028'), fullWidth: true, placeholder: t('L000024'), variant: 'outlined', size: 'medium', type: 'number' }),
        _jsx(BaseTextFieldForm, { name: 'name', label: t('L000027'), fullWidth: true, placeholder: t('L000025'), variant: 'outlined', size: 'medium' }),
        _jsx(BaseDatePickerFormV2, { name: 'date', label: t('L000014'), multiple: true }),
        _jsx(BaseSelectForm, { name: 'status', label: t('L000004'), placeholder: t('L000026'), options: status })
    ];
    return { listFilters: listFilters };
};
export default useGetFilterList;
